const SINGLE = 'Single';
const MULTIPLE = 'Multiple';

export default {
  SINGLE,
  MULTIPLE,
};
